import API from "@lib/axiosConfig";

export default url => API.get(url);
